import type { IntlShape } from "react-intl"

import type { PropertyJsonldReadItemProperty } from "@/networking/api"
import { get_t11n_label } from "@/utils/i18n/t11n"
import { isBlank, isNotBlank, ucfirst } from "@/utils/ts-utils"

/*const ucfirst = (str: string | undefined): string | undefined => {
  if (str === undefined) return undefined

  return str.replace(/(^| |-)[^ -]/g, v => v.toUpperCase())
}*/

type GetDisplayedNameMode = "TCS" | "TC" | "TS" | "T" // Type City Surface

export const getDisplayedName = (
  property: PropertyJsonldReadItemProperty,
  intl: IntlShape,
  mode: GetDisplayedNameMode = "TCS",
  isShared?: boolean
): string => {
  let type = ucfirst(get_t11n_label(property.type, intl), true)
  if (isBlank(type)) type = intl.formatMessage({ id: "entity.property.label" })

  const field = isShared ? "city" : "publicCity"
  const city = property.contactDetails?.[0]?.contactDetails?.[field] ?? ""
  let surface = (property.areaValue ?? "") as string
  const unit = get_t11n_label(property.areaUnit, intl)
  if (isNotBlank(surface) && isNotBlank(unit)) surface += ` ${unit}`

  if (mode === "T" || (isBlank(city) && isBlank(surface)) || (mode === "TC" && isBlank(city)))
    return type

  if (mode === "TS" || (isBlank(city) && isNotBlank(surface)))
    return intl.formatMessage(
      { id: "entity.property.title_type_surface" },
      {
        type,
        surface,
      }
    )

  if (mode === "TC" || (isNotBlank(city) && isBlank(surface)))
    return intl.formatMessage(
      { id: "entity.property.title_type_city" },
      {
        type,
        city,
      }
    )

  return intl.formatMessage(
    { id: "entity.property.title" },
    {
      type,
      city,
      surface,
    }
  )
}
